import { Location, SessionInputs, GamePlayData, SkillStates, LocationEnum, WaveHeight } from '../types'
import LOCATIONS from '../constants/locations'
import { getRandomWeightedValue } from '@/utils'

const FITNESS_TO_WAVE_PERIOD_MULTIPLIER = 0.5
const WAVE_READING_TO_WAVE_PERIOD_MULTIPLIER = 0.5
export const WAVE_HEIGHT_TO_WAVE_PERIOD_MAP: { [key in WaveHeight]: number } = {
  knee_high: 3,
  waist_high: 6,
  shoulder_high: 11,
  head_high: 18,
  overhead: 40,
  one_and_half_overhead: 80,
  two_overhead: 130,
  three_overhead: 250,
  big_wave: 400
}

export function generateSessionInputs(
  locationKey: LocationEnum,
  skills: SkillStates,
  isWhiteWater: boolean
): SessionInputs {
  const location: Location = LOCATIONS[locationKey]
  const waveType = getRandomWeightedValue(location.waveType)
  const waveHeight = getRandomWeightedValue(location.waveHeight) as WaveHeight
  const crowd = getRandomWeightedValue(location.crowd)
  const crowdSkill = getRandomWeightedValue(location.crowdSkill)

  const whiteWaterWavePeriodBoost = isWhiteWater ? 0.8 : 0
  const wavePeriodSKillMultiplier =
    (skills.fitness.level || 1) * FITNESS_TO_WAVE_PERIOD_MULTIPLIER +
    (skills.wave_reading.level || 0) * WAVE_READING_TO_WAVE_PERIOD_MULTIPLIER +
    whiteWaterWavePeriodBoost

  const forecastingAndObservingImpact = 1 - (skills.forecasting_and_observing.level || 0) * 0.13
  const wavePeriod = Math.max(
    1.5,
    (WAVE_HEIGHT_TO_WAVE_PERIOD_MAP[waveHeight] / wavePeriodSKillMultiplier) * forecastingAndObservingImpact
  )
  return {
    waveType,
    waveHeight,
    crowd,
    crowdSkill,
    wavePeriod
  }
}
